<div class="flex flex-col">
  <div
    class="mat-mdc-menu-content"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    @for (column of columns(); track $index) {
      @if (!column.native) {
        <button
          mat-menu-item
          cdkDrag
          cdkDragPreviewContainer="parent"
          (click)="$event.stopPropagation()"
          cdkDragLockAxis="y"
        >
          <mat-checkbox
            (click)="$event.stopPropagation()"
            [checked]="model()[column.key] ?? column.display"
            [disabled]="column.locked ?? false"
            (change)="onCheckboxChange(column.key, $event.checked)"
          >
            {{ column.label }}
          </mat-checkbox>

          <div class="flex flex-auto justify-end">
            <mat-icon cdkDragHandle class="cursor-grab" svgIcon="grip-vertical" />
          </div>
          <div *cdkDragPlaceholder class="h-8 rounded-md bg-neutral-a3"></div>
        </button>
      }
    } @empty {
      <div mat-menu-item>
        <span class="text-sm text-neutral-a9">No columns to customize</span>
      </div>
    }
  </div>
</div>
